import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { OeeAppState } from '../../../store/oee.reducer';

@Component({
    selector: 'page-loader',
    templateUrl: './page-loader.component.html',
    styleUrls: ['./page-loader.component.scss'],
    standalone: false
})
export class PageLoaderComponent implements OnDestroy, OnInit {
  public loading$: boolean;
  public loadingText$: string;
  private appStoreSubscription: Subscription;

  constructor(private store: Store<OeeAppState>) {}

  ngOnDestroy(): void {
    if (this.appStoreSubscription) {
      this.appStoreSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.appStoreSubscription = this.store.select('app').subscribe((state) => {
      this.loading$ = state.loading;
      this.loadingText$ = state.loadingText;
    });
  }
}
